import React, { useEffect } from "react";
import { Redirect, Switch, useHistory } from "react-router-dom";

import SignIn from "../../pages/SignIn";
import Dashboard from "../../pages/Dashboard";
import ContactForm from "../../pages/ContactForm";
import ForgotPassword from "../../pages/ForgotPassword";
import Faq from "../../pages/Faq";

import {
  loadUser,
  logoutRequest,
  preLogoutRequest,
} from "../../redux/modules/auth/actions";
import { getNotifications } from "../../redux/modules/notification/actions";
import { loadLanguagePreference } from "../../redux/modules/language/actions";
import { alertReset } from "../../redux/modules/alerts/actions";
import { useToast } from "../../hooks/toast";

import { useDispatch, useSelector } from "react-redux";

import Route from "./Route";
import { useIntl } from "react-intl";
import FaqCreation from "../../pages/Faq/Create";
import FaqEdition from "../../pages/Faq/Edit";
import FaqVisualization from "../../pages/Faq/Visualization";
import Events from "../../pages/Events";
import Checklist from "../../pages/Checklist";
import ChecklistItem from "../../pages/Checklist/ChecklistItem";
import EventDetail from "../../pages/Events/Detail";
import api from "../../service";
import EventClientVisualization from "../../pages/Events/ClientVisualization";
import EventClientVisualizationDetail from "../../pages/Events/ClientVisualization/Detail";
import Contracts from "../../pages/Contracts";
import ContractDetail from "../../pages/Contracts/Detail";
import Accounts from "../../pages/Accounts";
import ServiceProviders from "../../pages/ServiceProviders";
import AccountDetail from "../../pages/Accounts/Details";
import Users from "../../pages/Users";
import Logs from "../../pages/Logs";
import AdminAssociateCollaborators from "../../pages/AdminCollaborators/Associate";
import AdminAssociateCollaboratorsDetail from "../../pages/AdminCollaborators/Associate/Detail";
import AdminAssociateCollaboratorsCreate from "../../pages/AdminCollaborators/Associate/Create";
import Profiles from "../../pages/Profiles";
import NewProfile from "../../pages/Profiles/New";
import EditProfile from "../../pages/Profiles/Edit";
import ExhibitorOpenID from "../../pages/OpenID/Exhibitor";
import ServiceProviderOpenID from "../../pages/OpenID/ServiceProvider";
import StaffOpenID from "../../pages/OpenID/Staff";
import AdminEditServiceProvider from "../../pages/AdminEditUser/ServiceProvider";
import SignInForm from "../../pages/SignIn/Form";

import ClientServiceProviderAssociation from "../../pages/ServiceProviderAssociation/Client";
import ClientServiceProviderAssociationProviderView from "../../pages/ServiceProviderAssociation/Client/ServiceProviderView";
import ClientServiceProviderBoothView from "../../pages/ServiceProviderAssociation/Client/ServiceProviderBoothView";
import ClientCreateAssociation from "../../pages/ServiceProviderAssociation/Client/CreateAssociation";

import AdminServiceProviderAssociation from "../../pages/ServiceProviderAssociation/Admin";
import AdminCreateAssociation from "../../pages/ServiceProviderAssociation/Admin/CreateAssociation";

// import UsersJourney from "../../pages/Accounts/Details/Journey";
import Logout from "../../pages/Logout";
// import ManageGuests from "../../pages/ManageGuests";
// import NewGuest from "../../pages/ManageGuests/New";
// import EditGuest from "../../pages/ManageGuests/Edit";
import AdminManageGuests from "../../pages/AdminManageGuests";
import AdminNewGuest from "../../pages/AdminManageGuests/New";
import AdminEditGuest from "../../pages/AdminManageGuests/Edit";
import ManageCredentials from "../../pages/ManageCredentials";
import AdminGuestsReport from "../../pages/AdminGuestsReport";
import AdditionalProducts from "../../pages/AdditionalProducts";
import NewAdditionalProducts from "../../pages/AdditionalProducts/New";
import EditAdditionalProducts from "../../pages/AdditionalProducts/Edit";
import ProductEventAssociation from "../../pages/ProductEventAssociation";
import ProductEventAssociationItem from "../../pages/ProductEventAssociation/Item";
import Category from "../../pages/Category";
import NewCategory from "../../pages/Category/New";
import EditCategory from "../../pages/Category/Edit";
import AuthSSO from "../../pages/AuthSSO";
import { useLoading } from "../../hooks/loading";
import Cockpit from "../../pages/Cockpit";
import ManageCredentialReport from "../../pages/AdminCredentialReport";
import ManageCredentialScheduleReport from "../../pages/AdminCredentialScheduleReport";
import EventSetupParameters from "../../pages/EventSetup/Parameters";
import EventSetup from "../../pages/EventSetup";
import EventSetupCreate from "../../pages/EventSetup/Create";
import EventSetupEdit from "../../pages/EventSetup/Edit";
import ManageAdminExhibitorsAccessByEventReport from "../../pages/AdminExhibitorsAccessByEventReport";
import ManageExhibitorsDidNotCreateCredentialsReport from "../../pages/AdminExhibitorsDidNotCreateCredentialsReport";
import ManageServiceProvidersAssociatedReport from "../../pages/AdminServiceProvidersAssociatedReport";
import ManageDigitalProductsReport from "../../pages/AdminDigitalProductsReport";
import AuthSSOError from "../../pages/AuthSSOError";
import ManageHeadbandReport from "../../pages/AdminHeadbandReport";
import EventSetupHelpdesk from "../../pages/AdminEventSetupHelpdesk";
import StaffAccess from "../../pages/StaffAccess";
import StaffSelectEvent from "../../pages/StaffAccess/SelectEvent";
import StaffSelectClient from "../../pages/StaffAccess/SelectClient";
import StaffServicePanel from "../../pages/StaffAccess/ServicePanel";
import StaffServiceContract from "../../pages/StaffAccess/Services/Contract";
import StaffServiceCredentials from "../../pages/StaffAccess/Services/Credentials";
import StaffCredentialsCollaboratorsList from "../../pages/StaffAccess/Services/Credentials/Collaborators";
import StaffCategories from "../../pages/StaffJourney/Categories";
import NewStaffAccess from "../../pages/StaffAccess/New";
import EditStaffAccess from "../../pages/StaffAccess/Edit";
import ManageOrderReport from "../../pages/AdminOrderReport";
import NotFound from "../../pages/NotFound";
import ManageServiceProvidersReport from "../../pages/AdminServiceProvidersReport";
import ImpersonateUser from "../../pages/ImpersonateUser";
import ManageExhibitorsAssociatedCredentialsSyntheticReport from "../../pages/AdminExhibitorsAssociatedCredentialsSyntheticReport";
import ManageCustomersJourneyReport from "../../pages/AdminCustomersJourneyReport";
import UpdateRegistrationDataSerpro from "../../pages/UpdateRegistrationDataSerpro";
import AdminCredentialTransfer from "../../pages/AdminCredentialTransfer";
import AdminCreateCredentialTransfer from "../../pages/AdminCredentialTransfer/Create";
import ManageFilteredSalesforceEventEditions from "../../pages/SalesforceEventEditions";
import CreateFilteredSalesforceEventEditions from "../../pages/SalesforceEventEditions/Create";
import EditFilteredSalesforceEventEditions from "../../pages/SalesforceEventEditions/Edit";
import ManageSwapcardIntegrationReport from "../../pages/AdminSwapcardIntegrationReport";
import ConsultProviderByEvent from "../../pages/ConsultProviderByEvent";
import AccountJourney from "../../pages/AccountJourney";
import Invoices from "../../pages/Invoices";
import ManageDuplicatedProductsReport from "../../pages/AdminDuplicatedProductsReport";
import ManageContractualProductsReport from "../../pages/AdminContractualProductsReport";
import ImportCollaborator from "../../pages/ImportCollaborator";
import ManageHomepageBanner from "../../pages/AdminManageHomepageBanner";
import InformaAcademy from "../../pages/InformaAcademy";
import NewCourseInformaAcademy from "../../pages/InformaAcademy/new";
import InformaAcademyAnalytics from "../../pages/InformaAcademy/Analytics";
import ExhibitorManual from "../../pages/Manual";
import EditCourse from "../../pages/InformaAcademy/EditCourse";
import NewManual from "../../pages/Manual/newManual";
import ManageManual from "../../pages/Manual/manageManual";
import ManageChapters from "../../pages/Manual/components/chapter";
import ManageFAQ from "../../pages/Manual/components/FAQ";
import NewArticle from "../../pages/Manual/components/article/new-article";
import EditArticle from "../../pages/Manual/components/article/edit-article";
import ArticleDetails from "../../pages/Manual/components/article/article-details";
import CreateNewHomePage from "../../pages/AdminManageHomepageBanner/CreateHomePage";
import EditHomePage from "../../pages/AdminManageHomepageBanner/EditHomePage";
import AICreatorReport from "../../pages/AI_CreatorReport/page";
import BonusCredential from "../../pages/BonusCredential";
import Defaulters from "../../pages/Defaulters";
import StaffServiceSales from "../../pages/StaffAccess/Services/Sales";
import StaffServiceTransferHistory from "../../pages/StaffAccess/Services/TransferHistory";
import ContractProducts from "../../pages/StaffAccess/Services/Sales/ContractProducts";
import Checkout from "../../pages/StaffAccess/Services/Sales/Checkout";
import PurchaseSummary from "../../pages/StaffAccess/Services/Sales/PurchaseSummary";
import StaffAssistance from "../../pages/StaffAssistance";
import AdminUploadDocuments from "../../pages/AdminDocuments";
import SignInSelfService from "../../pages/SignIn/SelfService";
import { SelfService } from "../../newUXPages/SelfService";
import Flow from "../../pages/AdminDocuments/Flow";
import ApprovalDocuments from "../../pages/AdminDocuments/ApprovalDocuments";
import AnalyticsDocuments from "../../pages/AdminDocuments/AnalyticsDocuments";
import AnalyticsInsurance from "../../pages/AdminDocuments/AnalyticsInsurance";
import AdminManegeTotemAccess from "../../pages/AdminAccessManagement/ManageTotemAccess";
import { ManageAccessForm } from "../../pages/AdminAccessManagement/ManageTotemAccess/components/TotemForm";
import AdminManegeCredentialTemplate from "../../pages/AdminAccessManagement/CredentialTemplate";
import { CredentialTemplateForm } from "../../pages/AdminAccessManagement/CredentialTemplate/components/CredentialsTemplateForm";
import AdminManegeTotemDashboard from "../../pages/AdminAccessManagement/Dashboard";
import TotemPositionConfiguration from "../../pages/AdminAccessManagement/TotemPositionConfiguration";
import ReasonsDisapprovalDocuments from "../../pages/AdminDocuments/ReasonsDisapprovalDocuments";
import TotemPositionConfigurationList from "../../pages/AdminAccessManagement/TotemPositionConfiguration/List";

const Routes = () => {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.alerts);
  const { user, token, executeLogout } = useSelector((state) => state.auth);
  const { addToast } = useToast();
  const intl = useIntl();
  const history = useHistory();
  const { debouncing, isAccountLoading, handleAccountLoading, handleLoading } =
    useLoading();

  useEffect(() => {
    if (message.isDialog) {
      addToast({
        type: message.messageType,
        title: intl.formatMessage({
          id: message.title,
        }),
        description: intl.formatMessage({
          id: message.message,
        }),
      });
      dispatch(alertReset());
    }
  }, [message, addToast, intl, dispatch]);

  useEffect(() => {
    dispatch(loadUser());
    dispatch(loadLanguagePreference());
  }, [dispatch]);

  useEffect(() => {
    if (executeLogout) {
      dispatch(
        logoutRequest({
          token,
          callbackLoading: handleLoading,
          tokenExpired: true,
          user: user,
        })
      );
    }
  }, [dispatch, executeLogout, handleLoading, token, user]);

  useEffect(() => {
    if (!user && history.location.pathname === "/") {
      const script = document.createElement("script");

      script.src = process.env.REACT_APP_WEBCHAT;
      script.defer = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [user]);

  const UNAUTHORIZED = 401;
  useEffect(() => {
    api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === UNAUTHORIZED) {
          if (isAccountLoading && debouncing) {
            handleAccountLoading(false);
            return Promise.reject(error);
          }
          handleLoading(true);
          dispatch(preLogoutRequest());
        }

        return Promise.reject(error);
      }
    );
  }, [
    user,
    history.location.pathname,
    dispatch,
    handleLoading,
    executeLogout,
    token,
    isAccountLoading,
    debouncing,
    handleAccountLoading,
  ]);

  useEffect(() => {
    if (user && history.location.pathname !== "/logout") {
      dispatch(
        getNotifications({
          token,
        })
      );
    }

    return history.listen((location) => {
      if (
        location.pathname !== "/update-user" &&
        location.pathname !== "/" &&
        location.pathname !== "/logout"
      ) {
        if (user) {
          if (!isAccountLoading) {
            dispatch(
              getNotifications({
                token,
              })
            );
          }
        }
      }
    });
  }, [user, history, dispatch, token]);

  const hasAccessToWiki =
    String(process.env.REACT_APP_HAS_ACCESS_TO_WIKI).toLowerCase() === "true";
  const hasAccessToAcademy =
    String(process.env.REACT_APP_HAS_ACCESS_TO_ACADEMY).toLowerCase() ===
    "true";
  const hasAccessToCreator =
    String(process.env.REACT_APP_HAS_ACCESS_TO_CREATOR).toLowerCase() ===
    "true";

  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/signin-form" exact component={SignInForm} />
      <Route path="/totem/:slug" exact component={SignInSelfService} />
      <Route path="/totem/:slug/details" exact component={SelfService} />
      <Route
        path="/dashboard"
        component={Dashboard}
        isPrivate
        code="ACCESS_KNOWLEDGE_BASE"
      />
      <Route
        path="/staff-access/select-event"
        component={StaffSelectEvent}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/select-client"
        component={StaffSelectClient}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/service-panel"
        component={StaffServicePanel}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/sales"
        component={StaffServiceSales}
        isPrivate
        exact
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/sales/contract-products"
        component={ContractProducts}
        isPrivate
        exact
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/sales/checkout"
        component={Checkout}
        isPrivate
        exact
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/sales/purchase-summary"
        component={PurchaseSummary}
        isPrivate
        exact
        roles={["STAFF", "ADMINISTRATOR"]}
      />

      <Route
        path="/staff-access/services/contract"
        component={StaffServiceContract}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/transfer-history"
        component={StaffServiceTransferHistory}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/services/credentials"
        component={StaffServiceCredentials}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff-access/credentials/collaborators"
        component={StaffCredentialsCollaboratorsList}
        isPrivate
        roles={["STAFF", "ADMINISTRATOR"]}
      />
      <Route
        path="/staff/bonus-credentials"
        component={BonusCredential}
        roles={["STAFF"]}
        isPrivate
        exact
      />

      <Route
        path="/staff-journey/categories"
        component={StaffCategories}
        isPrivate
        roles={["ADMINISTRATOR"]}
      />

      <Route
        path="/contact"
        component={ContactForm}
        isPrivate
        roles={["ADMINISTRATOR"]}
      />
      <Route
        path="/faq"
        exact
        component={Faq}
        isPrivate
        roles={["ADMINISTRATOR"]}
      />
      <Route
        path="/faq/create"
        component={FaqCreation}
        isPrivate
        roles={["ADMINISTRATOR"]}
      />
      <Route
        path="/faq/edit/:id"
        component={FaqEdition}
        isPrivate
        roles={["ADMINISTRATOR"]}
      />
      <Route path="/faq-visualization" component={FaqVisualization} isPrivate />
      <Route
        path="/events"
        exact
        component={Events}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/events/:id"
        component={EventDetail}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/events-exhibitor-visualization"
        exact
        component={EventClientVisualization}
        isPrivate
      />
      <Route
        path="/events-exhibitor-visualization/:id"
        component={EventClientVisualizationDetail}
        isPrivate
      />
      <Route
        path="/event-checklist/:id"
        exact
        component={Checklist}
        isPrivate
      />
      <Route
        path="/event-checklist/:id/item/create"
        exact
        component={ChecklistItem}
        isPrivate
      />
      <Route
        path="/event-checklist/:id/item/edit/:itemId"
        exact
        component={ChecklistItem}
        isPrivate
      />
      <Route path="/accounts" exact component={Accounts} isPrivate />
      <Route
        path="/service-providers-management"
        exact
        component={ServiceProviders}
        isPrivate
      />
      <Route path="/account/:id" component={AccountDetail} isPrivate />
      <Route path="/users" component={Users} isPrivate />
      <Route path="/logs" component={Logs} isPrivate />
      <Route
        path="/serviceprovider-association"
        exact
        component={ClientServiceProviderAssociation}
        roles={["EXHIBITOR"]}
        isPrivate
      />
      <Route
        path="/serviceprovider/association-provider-view"
        exact
        component={ClientServiceProviderAssociationProviderView}
        isPrivate
      />
      <Route
        path="/serviceprovider-association-provider-detail"
        component={ClientServiceProviderBoothView}
        isPrivate
      />
      <Route
        path="/serviceprovider-association/new"
        exact
        component={ClientCreateAssociation}
        roles={["EXHIBITOR"]}
        isPrivate
      />
      <Route
        path="/admin/serviceprovider-association"
        exact
        component={AdminServiceProviderAssociation}
        roles={["ADMINISTRATOR", "STAFF"]}
        isPrivate
      />
      <Route
        path="/admin/serviceprovider-association/new"
        exact
        component={AdminCreateAssociation}
        roles={["ADMINISTRATOR", "STAFF"]}
        isPrivate
      />
      <Route
        path="/admin/associate-collaborators"
        exact
        component={AdminAssociateCollaborators}
        isPrivate
      />
      <Route
        path="/admin/associate-collaborator/edit/:id"
        exact
        component={AdminAssociateCollaboratorsDetail}
        isPrivate
      />
      <Route
        path="/manage-credentials/new"
        exact
        component={AdminAssociateCollaboratorsCreate}
        isPrivate
      />
      <Route
        path="/admin/impersonate-user"
        exact
        component={ImpersonateUser}
        isPrivate
      />
      <Route path="/logout" component={Logout} isPrivate />
      <Route path="/profiles" exact component={Profiles} isPrivate />
      <Route path="/profiles/new" component={NewProfile} isPrivate />
      <Route path="/profile/:id" component={EditProfile} isPrivate />
      <Route
        path="/admin/service-provider-edit/:id"
        roles={["ADMINISTRATOR", "STAFF"]}
        component={AdminEditServiceProvider}
        isPrivate
      />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route
        path="/contracts"
        exact
        component={Contracts}
        roles={["ADMINISTRATOR", "STAFF"]}
        isPrivate
      />
      <Route path="/contract/:id" component={ContractDetail} isPrivate />
      <Route
        path="/auth/exhibitor-openid-signin"
        exact
        component={ExhibitorOpenID}
      />
      <Route
        path="/auth/3rdparth-openid-signin"
        exact
        component={ServiceProviderOpenID}
      />
      <Route path="/auth/staff-openid-signin" exact component={StaffOpenID} />
      <Route path="/auth/informa-sso-signin" exact component={AuthSSO} />
      <Route path="/auth/informa-sso-error" exact component={AuthSSOError} />
      <Route path="/cockpit" component={Cockpit} isPrivate />
      <Route
        exact
        path="/admin/upload-documents"
        component={AdminUploadDocuments}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        exact
        path="/admin/upload-documents/flow/new"
        component={Flow}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        exact
        path="/admin/upload-documents/flow/:id/:action"
        component={Flow}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        exact
        path="/admin/approval-documents"
        component={ApprovalDocuments}
        roles={["ADMINISTRATOR", "STAFF"]}
        isPrivate
      />
      <Route
        exact
        path="/admin/analytics-documents"
        component={AnalyticsDocuments}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
       <Route
        exact
        path="/admin/reasons-disapproval-documents"
        component={ReasonsDisapprovalDocuments}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        exact
        path="/admin/analytics-insurance"
        component={AnalyticsInsurance}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/search-journey"
        component={AccountJourney}
        isPrivate
      />
      <Route
        path="/admin/manage-guests"
        exact
        component={AdminManageGuests}
        isPrivate
      />
      <Route
        path="/admin/manage-guests/new"
        exact
        component={AdminNewGuest}
        isPrivate
      />
      <Route
        path="/admin/manage-guests/:id"
        component={AdminEditGuest}
        isPrivate
      />
      <Route
        path="/manage-credentials"
        exact
        component={ManageCredentials}
        isPrivate
      />
      <Route
        path="/admin/guests-report"
        exact
        component={AdminGuestsReport}
        isPrivate
      />
      <Route
        path="/admin/credential-report"
        exact
        component={ManageCredentialReport}
        isPrivate
      />
      <Route
        path="/admin/credential-schedule-report"
        exact
        component={ManageCredentialScheduleReport}
        isPrivate
      />
      <Route
        path="/admin/additional-products"
        exact
        component={AdditionalProducts}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/additional-products/new"
        exact
        component={NewAdditionalProducts}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/additional-products/:id"
        exact
        component={EditAdditionalProducts}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/categories"
        exact
        component={Category}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/manage-defaulters"
        exact
        component={Defaulters}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/categories/new"
        exact
        component={NewCategory}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/categories/:id"
        exact
        component={EditCategory}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/product-event-association"
        exact
        component={ProductEventAssociation}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/product-event-association/new"
        exact
        component={ProductEventAssociationItem}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/product-event-association/:id"
        exact
        component={ProductEventAssociationItem}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/event-setup"
        exact
        component={EventSetup}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/exhibitors-access-by-event-report"
        exact
        component={ManageAdminExhibitorsAccessByEventReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/event-setup/new"
        exact
        component={EventSetupCreate}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/exhibitors-didnt-create-credential-report"
        exact
        component={ManageExhibitorsDidNotCreateCredentialsReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/event-setup/:id"
        exact
        component={EventSetupEdit}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/providers-associated-report"
        exact
        component={ManageServiceProvidersAssociatedReport}
        roles={["ADMINISTRATOR", "STAFF"]}
        isPrivate
      />
      <Route
        path="/admin/digital-products-report"
        exact
        component={ManageDigitalProductsReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/event-setup/parameters/:id"
        exact
        component={EventSetupParameters}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/headband-report"
        exact
        component={ManageHeadbandReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/event-setup-helpdesk"
        exact
        component={EventSetupHelpdesk}
        isPrivate
      />
      <Route path="/staff-access" exact component={StaffAccess} isPrivate />
      <Route
        path="/staff-access/new"
        exact
        component={NewStaffAccess}
        isPrivate
      />
      <Route path="/staff-access/:id" component={EditStaffAccess} isPrivate />
      <Route
        path="/admin/service-providers-report"
        exact
        component={ManageServiceProvidersReport}
        isPrivate
      />
      <Route
        path="/admin/order-report"
        exact
        component={ManageOrderReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/exhibitors-associated-credential-synthetic"
        exact
        component={ManageExhibitorsAssociatedCredentialsSyntheticReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/action-control-and-event-indicators-report"
        exact
        component={ManageCustomersJourneyReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/update-registration-data"
        exact
        component={UpdateRegistrationDataSerpro}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin-credential-transfer"
        exact
        component={AdminCredentialTransfer}
        isPrivate
      />
      <Route
        path="/admin-credential-transfer/new"
        exact
        component={AdminCreateCredentialTransfer}
        isPrivate
      />
      <Route
        path="/manage-salesforce-event-editions"
        exact
        component={ManageFilteredSalesforceEventEditions}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/manage-salesforce-event-editions/new"
        exact
        component={CreateFilteredSalesforceEventEditions}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/manage-salesforce-event-editions/:id"
        exact
        component={EditFilteredSalesforceEventEditions}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/digital-platform-integration-report"
        exact
        component={ManageSwapcardIntegrationReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/consult-provider-by-event"
        exact
        component={ConsultProviderByEvent}
        isPrivate
      />
      <Route path="/invoices" exact component={Invoices} isPrivate />
      <Route path="/not-found" isPrivate component={NotFound} />

      <Route
        path="/admin/duplicated-products-report"
        exact
        component={ManageDuplicatedProductsReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />

      <Route
        path="/admin/contractual-products-report"
        exact
        component={ManageContractualProductsReport}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />

      <Route
        path="/staff/contractual-products-report"
        exact
        component={ManageContractualProductsReport}
        roles={["STAFF"]}
        isPrivate
      />

      <Route
        path="/import-collaborator"
        exact
        component={ImportCollaborator}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />

      {/* SESSION 1 - hasAccessToAcademy */}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy"
          exact
          component={InformaAcademy}
          isPrivate
          roles={["ADMINISTRATOR"]}
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/manage-homepage/"
          component={ManageHomepageBanner}
          roles={["ADMINISTRATOR"]}
          exact
          isPrivate
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/manage-homepage/create/:eventId"
          component={CreateNewHomePage}
          roles={["ADMINISTRATOR"]}
          isPrivate
          exact
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/manage-homepage/edit/:eventId"
          component={EditHomePage}
          roles={["ADMINISTRATOR"]}
          isPrivate
          exact
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/analytics"
          exact
          component={InformaAcademyAnalytics}
          isPrivate
          roles={["ADMINISTRATOR"]}
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/courses/new"
          exact
          component={NewCourseInformaAcademy}
          isPrivate
          roles={["ADMINISTRATOR"]}
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/admin/informa-academy/courses/:courseId"
          exact
          component={EditCourse}
          isPrivate
          roles={["ADMINISTRATOR"]}
        />
      )}
      {/* SESSION 1 - END */}

      {/* SESSION 1 - hasAccessToCreator */}
      {hasAccessToCreator && (
        <Route
          path="/admin/ai-creator-report"
          exact
          component={AICreatorReport}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {/* SESSION 1 - END */}

      <Route
        path="/admin/staff-assistance"
        component={StaffAssistance}
        roles={["ADMINISTRATOR"]}
        isPrivate
        exact
      />

      <Route
        path="/admin/bonus-credentials"
        component={BonusCredential}
        roles={["ADMINISTRATOR"]}
        isPrivate
        exact
      />
      <Route
        path="/admin/access-management"
        component={AdminManegeTotemAccess}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/access-management-dashboard"
        component={AdminManegeTotemDashboard}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/totem-position-configuration"
        component={TotemPositionConfigurationList}
        roles={["ADMINISTRATOR"]}
        code="MANAGE_TOTEM_POSITIONS"
        isPrivate
        exact
      />
      <Route
        path="/admin/totem-position-configuration/edit/:eventId?"
        component={TotemPositionConfiguration}
        roles={["ADMINISTRATOR"]}
        code="MANAGE_TOTEM_POSITIONS"
        isPrivate
        exact
      />
      <Route
        path="/admin/credential-management/:chosenEvent?/:chosenEventName?/:chosenCredential?"
        component={AdminManegeCredentialTemplate}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/totem-form/:id?"
        component={ManageAccessForm}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />
      <Route
        path="/admin/credential-template-form/:chosenEvent/:chosenEventName/:chosenCredential/:modelId?"
        component={CredentialTemplateForm}
        roles={["ADMINISTRATOR"]}
        isPrivate
      />

      {/* SESSION 1 - hasAccessToWiki */}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual"
          component={ExhibitorManual}
          roles={["ADMINISTRATOR"]}
          isPrivate
          exact
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/new"
          exact
          component={NewManual}
          isPrivate
          roles={["ADMINISTRATOR"]}
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId"
          exact
          component={ManageManual}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId/FAQ"
          exact
          component={ManageFAQ}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId/chapters"
          exact
          component={ManageChapters}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId/newArticle"
          exact
          component={NewArticle}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId/details/:articleId"
          exact
          component={ArticleDetails}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/admin/manual/:manualId/edit/:articleId"
          exact
          component={EditArticle}
          roles={["ADMINISTRATOR"]}
          isPrivate
        />
      )}
      {/* SESSION 1 - END */}

      {/* Exclusive routes for clients (newUx) */}
      <Route path="/home" isPrivate component={NotFound} />
      <Route path="/checklist" isPrivate component={NotFound} />
      <Route path="/ecommerce" isPrivate component={NotFound} />
      <Route path="/leadsterplus" isPrivate component={NotFound} />
      <Route path="/user/view" isPrivate component={NotFound} />
      <Route path="/user/terms-of-use" isPrivate component={NotFound} />
      <Route path="/credentials" isPrivate component={NotFound} />
      <Route path="/credentials/associate" isPrivate component={NotFound} />
      <Route path="/credentials/register" isPrivate component={NotFound} />
      <Route path="/credentials/register/new" isPrivate component={NotFound} />
      <Route path="/credentials/register/edit" isPrivate component={NotFound} />
      <Route path="/credentials/schedule" isPrivate component={NotFound} />
      <Route path="/credentials/transfer" isPrivate component={NotFound} />
      <Route
        path="/credentials/transfer-history"
        isPrivate
        component={NotFound}
      />
      <Route
        path="/credentials/register/import-collaborator"
        isPrivate
        component={NotFound}
      />
      <Route path="/contract" component={NotFound} isPrivate />
      <Route path="/associate-company/view" isPrivate component={NotFound} />
      <Route path="/associate-company/new" isPrivate component={NotFound} />
      <Route path="/document" component={NotFound} isPrivate />
      <Route path="/document/not-send" component={NotFound} isPrivate />
      <Route path="/accounts-users" component={NotFound} isPrivate />

      {/* SESSION 2 - hasAccessToAcademy */}
      {hasAccessToAcademy && (
        <Route
          path="/informa-academy/:eventCode"
          component={NotFound}
          isPrivate
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/informa-academy/:eventCode/course/:courseId"
          component={NotFound}
          isPrivate
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/informa-academy/:eventCode/course/:courseId/lesson/:lessonId"
          component={NotFound}
          isPrivate
        />
      )}
      {hasAccessToAcademy && (
        <Route
          path="/informa-academy/:eventCode/:courseId/:lessonId"
          exact
          component={NotFound}
          isPrivate
        />
      )}
      {/* SESSION 2 - END */}

      {/* SESSION 2 - hasAccessToCreator */}
      {hasAccessToCreator && (
        <Route path="/ai-creator" component={NotFound} isPrivate />
      )}
      {/* SESSION 2 - END */}

      {/* SESSION 2 - hasAccessToWiki */}
      {hasAccessToWiki && (
        <Route path="/event-manual/:eventCode" component={NotFound} isPrivate />
      )}
      {hasAccessToWiki && (
        <Route
          path="/event-manual/:eventCode/chapter/:chapterId"
          exact
          component={NotFound}
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/event-manual/:eventCode/chapter/:chapterId/article/:articleId"
          component={NotFound}
          exact
          isPrivate
        />
      )}
      {hasAccessToWiki && (
        <Route
          path="/event-manual/:eventCode/search"
          component={NotFound}
          exact
          isPrivate
        />
      )}
      {/* SESSION 2 - END */}

      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
